import { Component } from '@theme/component';
import { fetchConfig } from '@theme/utilities';
import { CartAddEvent } from '@theme/events';

/**
 * Handles bundle upsell add-to-cart forms with AJAX so cart sections refresh in place.
 */
class BundleUpsellForm extends Component {
  requiredRefs = ['error'];

  handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const submitButton = this.querySelector('button');
    if (submitButton instanceof HTMLButtonElement) {
      submitButton.disabled = true;
    }

    let items = [];
    try {
      items = JSON.parse(this.dataset.items || '[]');
    } catch (error) {
      items = [];
    }

    if (!Array.isArray(items) || items.length === 0) {
      this.#showError();
      if (submitButton instanceof HTMLButtonElement) {
        submitButton.disabled = false;
      }
      return;
    }

    const formData = new FormData();
    items.forEach((item, index) => {
      formData.set(`items[${index}][id]`, String(item.id));
      formData.set(`items[${index}][quantity]`, String(item.quantity ?? 1));
    });

    const sectionIds = [];

    document.querySelectorAll('cart-items-component').forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionIds.push(item.dataset.sectionId);
      }
    });

    formData.set('sections', sectionIds.join(','));

    const fetchCfg = fetchConfig('javascript', { body: formData });

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        ...fetchCfg,
        headers: {
          ...fetchCfg.headers,
          Accept: 'text/html',
        },
      });

      const json = await response.json();

      if (json.status) {
        this.#showError();
        return;
      }

      this.#clearError();

      const itemCount = items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0) || 1;

      this.dispatchEvent(
        new CartAddEvent({}, this.dataset.productId || '', {
          source: 'bundle-upsell-form',
          itemCount,
          productId: this.dataset.productId,
          sections: json.sections,
        })
      );
    } catch (error) {
      this.#showError();
      console.error(error);
    } finally {
      if (submitButton instanceof HTMLButtonElement) {
        submitButton.disabled = false;
      }
    }
  };

  #showError() {
    const message = this.dataset.errorMessage || 'We could not add that item right now. Please try again.';
    this.refs.error.textContent = message;
    this.refs.error.classList.remove('hidden');
  }

  #clearError() {
    this.refs.error.textContent = '';
    this.refs.error.classList.add('hidden');
  }
}

if (!customElements.get('bundle-upsell-form')) {
  customElements.define('bundle-upsell-form', BundleUpsellForm);
}
